import { Text, Field } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import withValidDatasourceCheck from 'lib/enhancers/withValidDatasourceCheck';
import RichTextWrapper from './helpers/RichText/RichTextWrapper';

type ContentBlockProps = ComponentProps & {
  fields: {
    heading: Field<string>;
    content: Field<string>;
  };
};

/**
 * A simple Content Block component, with a heading and rich text block.
 * This is the most basic building block of a content site, and the most basic
 * JSS component that's useful.
 */
const ContentBlock = ({ fields }: ContentBlockProps): React.JSX.Element => (
  <div className="contentBlock">
    <Text tag="h2" className="contentTitle" field={fields.heading} />

    <RichTextWrapper className="contentDescription" field={fields.content} />
  </div>
);

export default withValidDatasourceCheck()<ContentBlockProps>(ContentBlock);
